import { getReportingStrings } from './useReportingStrings';

// One central list of one-sentence descriptions for every card, chart and table in the portal
// (spec FR-009). The text lives in src/EN.json and src/FR.json under reportingPortal.descriptions;
// the key names are listed here so a missing description is caught by the test.
export const DESCRIPTION_KEYS = [
  'ordersCreated', 'ordersSubmitted', 'totalPdfs', 'pdfSuccessRate', 'avgGenerationTime',
  'totalFileSize', 'totalEmails', 'emailSuccessRate', 'failedEmails', 'topOrderType', 'topProvince',
  'totalRequests', 'errorRate', 'avgResponseTime', 'requestsPerMinute', 'bfOrdersCreated',
  'bfOrdersSubmitted', 'bfPdfs', 'bfEmails', 'windowOrders', 'windowPdfs', 'windowEmails',
  'comparisonOrders', 'comparisonPdfs', 'comparisonEmails', 'hourlyCombined', 'ordersByType',
  'ordersByStatus', 'ordersByProvince', 'dailyOrderVolume', 'pdfTypes', 'pdfOrderTypes',
  'pdfLanguage', 'pdfHourly', 'emailTypes', 'emailSuccessVsFailed', 'emailHourly', 'emailDaily',
  'apiStatusCodeBreakdown', 'apiCategories', 'apiMethods', 'apiStatusCodes', 'apiHourly',
  'apiTopEndpoints', 'apiSlowestEndpoints', 'comparisonWithPreviousWeek', 'windowOrdersByType',
  'windowPdfsByType', 'windowEmailsByType', 'dailyTrend', 'periodComparison', 'periodOne',
  'periodTwo', 'exportHistory', 'ordersByLanguage', 'ordersByChannel'
];

export const getDescription = (locale, key) => {
  const descriptions = getReportingStrings(locale).descriptions || {};
  return descriptions[key] || '';
};

export default getDescription;
